import useSWR from 'swr'

import fetcher from 'utils/fetcher'

const useDocumentInboundPullAddress = () => {
  const { data, isValidating, mutate } = useSWR(
    '/document-inbound-pull-address',
    fetcher,
    {
      revalidateOnFocus: false,
    }
  )

  return {
    addresses: data?._embedded?.document_inbound_pull_address ?? [],
    loading:
      (!data?._embedded?.document_inbound_pull_address && !data?.error) ||
      isValidating,
    validating: isValidating,
    count: data?.count,
    total: data?.total,
    totalPages: data?.total_pages,
    pageSize: data?.page_size,
    paginates: data?.paginates,
    error: data?.error,
    mutate,
  }
}

export default useDocumentInboundPullAddress
